import type { enHangar } from './en-hangar';

/** Turkish strings — sockets + bag + loot clarity (docs/09, docs/03 wave 4). */
export const trHangar: Record<keyof typeof enHangar, string> = {
  'hud.pickupSocket': '+ {name} → soket {n}',
  'hud.pickupBag': '+ {name} → çanta',
  'hud.pickupFull': '+ {name} · çanta dolu: molada değiştir ya da hurdala',
  'hud.pickupScrap': '{name} → +{n} taş (yer yok / zaten var)',

  'shop.sockets': 'GEMİ',
  'shop.bag': 'ÇANTA',
  'shop.shipPower': 'GEMİ GÜCÜ',
} as const;
